/* eslint-disable react-hooks/exhaustive-deps */
import {useCallback, useEffect, useState} from "react"
import {BasePopup} from "components/popup"
import {BaseButton} from "components/buttons"
import styles from "./PopupCreateTask.module.css"
import {useMutation} from "@tanstack/react-query"
import {taskService} from "services"
import {handleError, handleErrorMessage, toastSuccess} from "helpers"
import moment from "moment"
import {useTasks} from "sections/Tasks/hooks/useTasks"
import {useModel} from "hooks"
import {BaseDatePicker} from "components/DateTimePicker"
import {FormLabel} from "components/Form"
import {cloneDeep} from "lodash"
import {BaseDepartmentId} from "types/departments"

type Props = {
    isShow: boolean
    studentProfileIds: number[]
    onClose: () => void
    onSuccess: () => void
    taskData?: any
}

export function PopupCreateTask(props: Props) {
    const {DEFAULT_TASK, getNewLibraryNextCode, formatSubmissionsAndTotalHoursCompletedTaskPayload} = useTasks()
    const model = useModel()
    const {isShow, studentProfileIds, onClose, onSuccess, taskData} = props
    const [monthYear, setMonthYear] = useState<any>(null)
    const [taskDataInfo, setTaskDataInfo] = useState<any>(cloneDeep(DEFAULT_TASK))

    useEffect(() => {
        if (taskDataInfo.id && isShow) {
            getNewNextCode()
        }
    }, [taskDataInfo.id, isShow])

    useEffect(() => {
        if (taskData) {
            setTaskDataInfo({...taskData})
        }
    }, [taskData])

    const getNewNextCode = async () => {
        const nextCode = await getNewLibraryNextCode(BaseDepartmentId.Academics, taskDataInfo.id)
        if (nextCode) {
            taskDataInfo.taskCode = nextCode
            setTaskDataInfo({...taskDataInfo})
        }
    }

    const createTaskMutation = useMutation(
        async (taskData: any): Promise<any> => {
            console.log("taskData---createTaskMutation--studentProfileIds--->>>", studentProfileIds)
            const monthYearFormated = moment(monthYear).format("MM-YYYY")
            const taskPayload = formatSubmissionsAndTotalHoursCompletedTaskPayload(taskDataInfo, monthYearFormated)
            const newTask = await taskService.createTask(taskPayload)
            const assignPayload = {
                taskId: newTask.id,
                signers: newTask.signers.map((signer) => ({
                    signerId: signer.id,
                    type: signer.type,
                    ...(signer.type === "staff"
                        ? {
                              users: [{profileId: model.profileId}]
                          }
                        : {users: studentProfileIds.map((profileId) => ({profileId}))})
                }))
            }
            await taskService.assignTask(assignPayload)

            return true
        },
        {
            onError: (error) => handleError(error)
        }
    )

    const handleCreateTask = useCallback(() => {
        if (!monthYear) {
            handleErrorMessage("Please select a month")
            return
        }
        createTaskMutation.mutate(taskData, {
            onSuccess: () => {
                toastSuccess("Created successfully")
                setMonthYear(null)
                onSuccess()
            }
        })
    }, [createTaskMutation, taskData, onSuccess, monthYear])

    const handleClose = () => {
        setMonthYear(null)
        onClose()
    }

    return (
        <BasePopup isShow={isShow} onClose={handleClose} leftIcon="EDIT_LINE" width="50vw">
            <div>
                <p className={styles.title}>Select the month</p>

                <div className={styles.modules}>
                    <FormLabel label="Select the month" />
                    <BaseDatePicker
                        onChange={(newValue) => setMonthYear(newValue)}
                        placeholder="Select month"
                        value={monthYear ? moment(monthYear) : ""}
                        disabledDate={(currentDate) => moment(currentDate).isAfter(moment())}
                        picker="month"
                        format="MM-YYYY"
                    />
                </div>

                <div className={styles.action}>
                    <BaseButton title="Cancel" variant="secondary" onClick={handleClose} />
                    <BaseButton title="Create" loading={createTaskMutation.isLoading} onClick={handleCreateTask} />
                </div>
            </div>
        </BasePopup>
    )
}
